import {useCallback} from 'react';

import {Spinner} from '../../../../../layout/spinner/spinner';
import {ReviewNoteType, useNotes} from '../../../../../service/reviews/reviews-notes';

import {NewNote} from './new-note/new-note';
import * as styles from './new-review-notes.scss';

type PropsType = {
    reviewId: number;
    notesCount: number;
};

export function NewReviewNotes(props: PropsType): JSX.Element | null {
    const {reviewId, notesCount} = props;
    const {data: notesList, isFetching: isInProgress, refetch: refreshNotes} = useNotes(reviewId, notesCount > 0);

    const refresh = useCallback(async () => {
        await refreshNotes();
    }, [refreshNotes]);

    return (
        <div className={styles.ReviewNotes}>
            <Spinner isShow={isInProgress} position="absolute" />
            {notesList?.results.map((note: ReviewNoteType) => {
                return (
                    <NewNote
                        createdAt={note.createdAt}
                        id={note.id}
                        key={note.id}
                        onNoteEdit={(_data) => refresh()}
                        refetchNotes={refresh}
                        reviewId={reviewId}
                        text={note.text}
                        updatedAt={note.updatedAt}
                        user={note.user}
                    />
                );
            })}
        </div>
    );
}
